import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { SortDescriptor } from '@progress/kendo-data-query';
import { getCurrentTenant, getIsConnectionStarted, getLobbyLocationSelected, getLobbyShowCategory, getLocationSelected, getLoggedInUserId, getLoggedInUserInfo, getSystemConfigurations, GetUserPermissionList } from 'src/app/state';
import { LobbyEntryService } from '../../shared/services/lobby-entry.service';
import { CentralStaffStatusViewGridRequest } from '../shared/models/central-staff-status-grid.request.model';
import { getCenralLobySelectedLocationIds, getStaffStatusGridData, State } from '../state';
import * as LobbyCentralStaffStatusViewActions from '../state/actions/lobby-central-views.actions';
import moment from 'moment';
import { Observable, Subscription } from 'rxjs';
import { CentralStaffStatusViewGridData } from '../shared/models/central-staff-status-view.model';
import * as _ from 'lodash';
import { GlobalDataService } from 'src/app/shared/services/global-data.service';
import { SystemConfigValue } from 'src/app/admin/system-configuration/shared/models/system-config-value';
import { ForceSignOutData } from '../../shared/models/force-signout-data';
import { LobbyService } from '../../shared/services/lobby.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { LocationSelectorItem } from 'src/app/shared/models/location-selector/location-selector-item-model';
import * as CentralLocationSelectorActions from '../state/actions/lobby-central-view-location-selector.actions';
import { LocationStateModel } from 'src/app/shared/models/location-selector/location-state.model';
import { LocationMultiSelector } from 'src/app/shared/models/location-selector/location-multi-selector-model';
import { take } from 'rxjs/operators';
import * as CoreActions from 'src/app/state/actions/core.actions';
import * as LobbyWrapUpPageActions from 'src/app/lobby/lobby-wrap-up/state/actions/wrap-up-page.actions';
import { TranslationLoaderFacade } from 'src/app/admin/localization/translation-loader.facade';
import { TranslateService } from '@ngx-translate/core';
import { ModalpopupComponent } from 'src/app/shared/modalpopup/modalpopup.component';
import { getPreferredLanguageId } from 'src/app/appointment/appointment-status-grid/state';

@Component({
  selector: 'app-lobby-central-staff-status-view',
  templateUrl: './lobby-central-staff-status-view.component.html',
  styleUrls: ['./lobby-central-staff-status-view.component.scss']
})
export class LobbyCentralViewComponent implements OnInit, OnDestroy {

  public dropdownSettings = { singleSelection: false, idField: 'id', textField: 'name', selectAllText: this.translateService.instant('_General_Select_All_Text_'), unSelectAllText: this.translateService.instant('_General_Unselect_All_Ts_Text_'), itemsShowLimit: 3, allowSearchFilter: true };
  public views = [{ id: 1, value: 'Central Lobby View' }, { id: 2, value: 'Central Staff Status View' }, { id: 3, value: 'Central Location View' }];
  public assistTypes = [{ id: 3, name: 'All' }, { id: 1, name: 'Standard' }, { id: 2, name: 'Instant' }];
  public sort: SortDescriptor[] = [{ field: 'locationName', dir: 'asc' }];
  public centralStaffStatusViewSubscriptions = new Subscription();

  public pageSize: number = 25;
  public skip: number = 0;
  public opened: boolean = false;
  public opened1: boolean = false;
  public GridData$?: Observable<CentralStaffStatusViewGridData>;
  public tenantId: number = 1;
  public searchObject: CentralStaffStatusViewGridRequest = {} as CentralStaffStatusViewGridRequest;
  public staffColumnText?: string;



  public selectedAssistType: number = this.assistTypes[0].id;
  public selectedLocations: number[] = [];
  public searchText: string | null = null;
  public interactionData: any;
  public lastInteractionData: any;
  public productAndServiceData: any;
  public sortingField: SortDescriptor[] = [{ field: 'LocationName', dir: 'asc' }]; 
  forceSignOutMessage: string = '';
  signedInlocationId?: number;
  
  public staffCurrentSignedInLocationId?: number;
  public utcOffSetForSignedInLocation: number = 0;
  public loggedInUserId?: number;
  private subs = new Subscription();
  private userIdToSignOut?: number;
  public userPermissionList?: number[];
  public checkedKeys: any[] = [];
  public selectorDisable: boolean = false;
  public currentAssistTimeExceeded = false;

  public interactionThreshold: any;
  private enabledInteractionThresholdAlert?: boolean;
  public isTimeExceeded: boolean = false;
  public enableUserImpersonationForTenant: boolean = false;
  public enableUserImpersonation: boolean = false;
  showLobbyCateogory: boolean = false;
  public signOutTitleText: string = '';
  public lobbyImperonateAssistAlertText: string= '';
  public currentlyAssistingSubText: string= '';
  
  enableAccountNumber: boolean = false;
  enableDateOfBirth: boolean = false;
  enableCustomField: boolean = false;
  constructor(public lobbyEntryService: LobbyEntryService,
    private store: Store<State>,
    public globalDataService: GlobalDataService,
    private lobbyService: LobbyService,
    private toastService: ToastService, 
    private translationLoaderFacade: TranslationLoaderFacade,
    private translateService: TranslateService) { }

  ngOnInit() {
    this.store.select(GetUserPermissionList).subscribe((allUserPermissions) => {
      this.userPermissionList = allUserPermissions;
    });

    const tenantSelectionSub = this.store.select(getCurrentTenant).subscribe((tenant) => {
      this.tenantId = tenant.tenantID;
    });

    const userSignininfoSub = this.store.select(getLobbyLocationSelected).subscribe(signedInLocationData =>
      this.utcOffSetForSignedInLocation = signedInLocationData.utcOffSet);

    this.subs.add(
      this.store.select(getSystemConfigurations).subscribe(
        (configurations) => {
          const lobbyConfigurations = configurations.filter(c => c.configurationGroup === 'LobbySettings');
          if (lobbyConfigurations.length > 0) {
            this.staffColumnText = this.readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'StaffStatusDisplayText'));
            this.enabledInteractionThresholdAlert = this.readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'EnableInteractionThresholdAlert'));
            this.enableUserImpersonationForTenant = this.readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'EnableUserImpersonation'))
            this.enableAccountNumber = this.readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'EnableAccountNumber'));
            this.enableDateOfBirth = this.readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'EnableDateOfBirth'));
            this.enableCustomField = this.readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'EnableCustomField'));
            if (this.enabledInteractionThresholdAlert) {
              this.interactionThreshold = this.readCastedValue(lobbyConfigurations.find(ac => ac.configurationName === 'InteractionThreshold'))
            }
          }
        }
      )
    );
    const userInfoSubscription = this.store.select(getLoggedInUserInfo).subscribe((userInfo) => {
      if (userInfo != null) {
        this.enableUserImpersonation = userInfo.enableUserImpersonation;
      }


    });
    const getLobbyCategorySub = this.store.select(getLobbyShowCategory).subscribe((lobbyCategory) => {

      this.showLobbyCateogory = lobbyCategory;

    });
    this.subs.add(userInfoSubscription);
    this.subs.add(tenantSelectionSub);
    this.subs.add(userSignininfoSub);
    this.subs.add(getLobbyCategorySub);
    const signalRConnectionSubscription = this.store.select(getIsConnectionStarted).subscribe(
      isHubConnected => {
        if (isHubConnected) {
          const getLocationSubs = this.store.select(getCenralLobySelectedLocationIds).subscribe((location) => {
            if (this.selectedLocations.length !== location.length || !_.isEqual(this.selectedLocations, location)) {
              this.selectedLocations = location;
              this.store.dispatch(LobbyCentralStaffStatusViewActions.loadCentralStaffStausViewGridData({ gridParams: this.getLobbyStaffStatusGridViewDataForInitially() }));
            }
          });

          this.centralStaffStatusViewSubscriptions.add(getLocationSubs);
        }
      }
    );

    this.centralStaffStatusViewSubscriptions.add(signalRConnectionSubscription);
    this.GridData$ = this.store.select(getStaffStatusGridData);
    this.store.select(getLoggedInUserId).subscribe(userId => this.loggedInUserId = userId);
    this.store.select(getLobbyLocationSelected).subscribe((location) => this.signedInlocationId = location.locationId);
    this.translateService.get(['_General_All_Text_','_Lobby_Standard_Ts_Text_','_Lobby_Instant_Ts_Text_', '_Shared_App_SignOut_Title_Text_', '_Lobby_Central_Impersonate_Assit_Alert_Text_', '_General_Currently_Assisting_Sub_Ts_Text_']).subscribe(
    (translations) => {
      this.assistTypes = [{ id: 3, name: translations['_General_All_Text_'] }, { id: 1, name: translations['_Lobby_Standard_Ts_Text_'] }, { id: 2, name: translations['_Lobby_Instant_Ts_Text_'] } ];
      this.signOutTitleText = translations['_Shared_App_SignOut_Title_Text_'];
      this.lobbyImperonateAssistAlertText = translations['_Lobby_Central_Impersonate_Assit_Alert_Text_'];
      this.currentlyAssistingSubText = translations['_General_Currently_Assisting_Sub_Ts_Text_'];
    });
  }
  public handleDefaultSelection(data: LocationMultiSelector) {

    var branchArray = data.locationsFlatData.filter(l => l.locationTypeId == 5);
    switch (branchArray.length) {
      case 0:
        this.selectorDisable = true;
        break;
      case 1:
        this.selectorDisable = true;
        this._setLocationSelectorDefaultValue();
        break;
      default:
        this._setLocationSelectorDefaultValue();
        break;
    }






  }
  public onTimeExceededHandler(event: boolean): void {
    this.isTimeExceeded = event;

  }
  public OpenWrapup(dataItem: any) {
    this.store.dispatch(LobbyWrapUpPageActions.loadWrapUpPopUp({ lobbyEntryId: dataItem.currentAssistingLobbyId, isImpersonateAssist: true, impersonatedByName: dataItem.staffName, showLobbyCateogory: this.showLobbyCateogory, impersonatedByCode: dataItem.staffCode }));
  }
  private _setLocationSelectorDefaultValue() {
    const centralLocationIdsSubscription = this.store.select(getCenralLobySelectedLocationIds).pipe(take(1)).subscribe((location) => {

      this.checkedKeys = location;

    });
    this.centralStaffStatusViewSubscriptions.add(centralLocationIdsSubscription);
  }
  public handleLocationData(items: LocationSelectorItem[] | any) {

    var locationStateArray: LocationStateModel[] = [];
    items.forEach(function (v: any) {
      var locateStateObj: LocationStateModel = {

        locationId: v.locationId,
        locationName: v.locationName,
        locationTypeId: v.locationTypeId
      };
      locationStateArray.push(locateStateObj);


    });

    this.store.dispatch(CentralLocationSelectorActions.setCentralLocationSelectorItemSelectAll({ selectedLocations: locationStateArray }));
    this.store.dispatch(CentralLocationSelectorActions.centralLocationSelectorItemChanged());
  }

  /**
   * Generate central lobby initial request
   */
  public getLobbyStaffStatusGridViewDataForInitially() {
    let initialSearchObject: CentralStaffStatusViewGridRequest = {} as CentralStaffStatusViewGridRequest;
    initialSearchObject.AssistTypeId = this.selectedAssistType == 3 ? null : this.selectedAssistType;
    if (this.selectedLocations != null && this.selectedLocations.length > 0) {
      initialSearchObject.LocationFilters = this.selectedLocations;
    }
    else {
      initialSearchObject.LocationFilters = [0];
    }
    initialSearchObject.Page = 1;
    initialSearchObject.PageSize = 25;
    initialSearchObject.SearchText = this.searchText;
    initialSearchObject.SortColumn = this.sortingField[0].field;
    initialSearchObject.SortDirection = this.sortingField[0].dir == 'asc' ? 'Ascending' : 'Descending';
    initialSearchObject.TenantId = this.tenantId;
    this.store.select(getPreferredLanguageId).pipe(take(1)).subscribe((langId: number) => {
      initialSearchObject.PreferredLanguageId = langId;
    });
    this.searchObject = JSON.parse(JSON.stringify(initialSearchObject));
    return initialSearchObject;
  }

  /*
  *Triggers when changing assistype drop down
  */
  public onAssistTypeChange() {
    this.store.dispatch(LobbyCentralStaffStatusViewActions.loadCentralStaffStausViewGridData({
      gridParams: Object.assign({}, this.searchObject,
        { AssistTypeId: this.selectedAssistType == 3 ? null : this.selectedAssistType }
      )
    }));
  }

  /**
   * Triggers when page change event triggers in the grid
   */
  public getLobbyCentralStaffStatusViewGridDataPageChangeEvent(event: any) {
    this.store.dispatch(LobbyCentralStaffStatusViewActions.loadCentralStaffStausViewGridData({
      gridParams: Object.assign({}, this.searchObject,
        { Page: (event.skip / event.take) + 1, PageSize: event.take }
      )
    }));
  }

  /**
   * Clear search text
   */
  public clearSearchKeyWordChange() {
    this.searchText = null;
    this.store.dispatch(LobbyCentralStaffStatusViewActions.loadCentralStaffStausViewGridData({
      gridParams: Object.assign({}, this.searchObject,
        { SearchText: this.searchText }
      )
    }));
  }

  /**
   *
   * Triggers when clicking info icon of row
   */
  public infoClickedHandler(event: any) {
    this.lobbyEntryService.getLobbyEntryDetails(event.dataItem.currentAssistingLobbyId).subscribe((lobbyEntryData) => {
      this.interactionData = lobbyEntryData;
      this.lastInteractionData = JSON.parse(JSON.stringify(lobbyEntryData.lobbyInteractions.find((data: any) => data.completedLocalTime == null)));
      let miliseconds = moment(moment.utc()).diff(moment.utc(this.lastInteractionData.assistedTime));
      let duration = moment.duration(miliseconds);
      this.interactionData['assistingLocalTime'] = duration.asSeconds();
      this.interactionData['assistingStartTime'] = this.lastInteractionData.assistedLocalTime;

      this.openInteractionDialog();
    })
  }

  /**
 *
 * Triggers when clicking info icon of row
 */
  public productClickedHandler(event: any) {
    this.lobbyEntryService.getLobbyEntryDetails(event.currentAssistingLobbyId).subscribe((lobbyEntryData) => {
      this.productAndServiceData = lobbyEntryData;
      this.openProductServiceDialog();
    })
  }


  /**
   * Triggers when the search key word changes
   *
   */
  public searchKeyWordChange() {
    let newSearchObject = _.cloneDeep(this.searchObject)
    this.store.dispatch(LobbyCentralStaffStatusViewActions.loadCentralStaffStausViewGridData({
      gridParams: Object.assign({}, this.searchObject,
        { SearchText: this.searchText }
      )
    }));

  }


  /**
   * Triggers when sort changed by the user
   * @param sort
   */
  public sortChange(sort: SortDescriptor[]) {
    this.sort = sort;
    switch (sort[0].field) {
      case 'locationName':
        this.sortingField[0].field = 'LocationName';
        break;
      case 'staffName':
        this.sortingField[0].field = 'StaffName';
        break;
      case 'status':
        this.sortingField[0].field = 'Status';
        break;
      case 'currentAssisting':
        this.sortingField[0].field = 'CurrentAssisting';
        break;
      case 'serviceRequested':
        this.sortingField[0].field = 'ServiceRequested';
        break;
      case 'currentAssistTime':
        this.sortingField[0].field = 'CurrentAssistTime';
        break;
    }


    let newSearchObject = _.cloneDeep(this.searchObject)
    newSearchObject.SortColumn = this.sortingField[0].field;
    newSearchObject.SortDirection = sort[0].dir == undefined ? "asc" : sort[0].dir
    this.searchObject = newSearchObject;

    if (newSearchObject != null) {
      this.store.dispatch(LobbyCentralStaffStatusViewActions.loadCentralStaffStausViewGridData({
        gridParams: newSearchObject
      }));
    }
  }

  /**
   * Closes when lobby info dialog closed
   */
  public closeInteractionDialog() {
    this.opened = false;
  }

  /**
   * Opens when lobby info icon clicked
   */
  public openInteractionDialog() {
    this.opened = true;
  }

  /**
  * Closes when product info dialog closed
  */
  public closeProductServiceDialog() {
    this.opened1 = false;
  }

  /**
   * Opens when product info icon clicked
   */
  public openProductServiceDialog() {
    this.opened1 = true;
  }


  ngOnDestroy(): void {
    this.subs.unsubscribe();
    this.centralStaffStatusViewSubscriptions.unsubscribe();
    const groupNames = [
      'CentralStaffStatusGridGroup'
    ];
    this.store.dispatch(CoreActions.unsubscribeFromSignalRGroups({ groupNames }));
  }

  private readCastedValue(systemConfigValue?: SystemConfigValue): any {
    if (systemConfigValue) {
      switch (systemConfigValue.dataType) {
        case 'int':
          return parseInt(systemConfigValue.value, undefined);
        case 'bool':
          return (systemConfigValue.value === '1');
        default:
          return systemConfigValue.value;
      }
    }
  }

  showSignOutTitle(dataItem: any) {
    const signOutTitle = `${this.signOutTitleText} ${dataItem.staffName}`;
    return signOutTitle;
  }

  showForceSignOutPopUp(rowData: any, popUp: ModalpopupComponent) {
    this.staffCurrentSignedInLocationId = rowData.locationId;
    this.userIdToSignOut = rowData.staffId;
    if(rowData.isProvideImpersonateAssist){
      this.forceSignOutMessage=`${rowData.staffName} ${this.lobbyImperonateAssistAlertText}`;
      popUp.dialogOpened = true;
    }
    else if (rowData.currentAssisting) {
      this.forceSignOutMessage = `${rowData.staffName} ${this.currentlyAssistingSubText}`;
      popUp.dialogOpened = true;
    }
    else {
      this._forceSignOut();
    }
  }

  public showForceSignOutIcon(dataItem: any) {
    if (dataItem.staffId === this.loggedInUserId || dataItem.statusId === 3) {
      return false;
    }
    return true;
  }


  userForceSignOut(popUp: any) {
    popUp.dialogOpen = false;
    this._forceSignOut();
  }

  private _getForceSignOutData() {
    const forceSignOutData: ForceSignOutData = {
      locationId: this.staffCurrentSignedInLocationId,
      signedOutByUserId: this.loggedInUserId,
      userIdToSignOut: this.userIdToSignOut,
      signedOutByUserLocationId: this.signedInlocationId,
      signedOutType: "backtolobby"
    };

    return forceSignOutData;
  }

  private _forceSignOut() {
    const forceSignOut = this._getForceSignOutData();
    this.lobbyService.userForceSignOut(forceSignOut).subscribe({
      next: () => { this.toastService.showSuccess('_General_User_Force_Sign_Out_Successfully_Ts_Text_') },
      error: () => { this.toastService.showError('_General_User_Force_Sign_Out_Failed_Ts_Text_') }
    });
  }

}
